import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { FormGroup, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { PeriodicElement } from '../document/document.component';
import { MatTableDataSource } from '@angular/material/table';
import {
  Gallery,
  GalleryItem,
  ThumbnailsPosition,
  ImageSize,
  ImageItem,
} from 'ng-gallery';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-document-history',
  templateUrl: './document-history.component.html',
  styleUrls: ['./document-history.component.scss'],
})
export class DocumentHistoryComponent implements OnInit {
  @Input() userDataItem;

  displayedColumns: string[] = [
    'verifiedOn',
    'verifiedBy',
    'status',
    'comment',
    'document',
  ];
  dataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection = new SelectionModel<PeriodicElement>(true, []);

  @ViewChild('itemTemplate', { static: true }) itemTemplate: TemplateRef<any>;
  selectedIndex = -1;
  userlist = [];
  userdata;
  restrictbutton = false;

  userHistory;
  userDataList: any;
  id;
  docDetails = false;
  showinput = false;
  documentbutton = true;
  filtershow = true;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    public _userService: UserManagementService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('personId');
    // this.getUser();
    this.getAlluser();
    this.getTraderData();
  }

  getUser() {
    var postdata = {
      userid: this.id,
    };
    this._userService.getUserVerificationHistory(postdata).subscribe((data) => {
      this.userHistory = data;
      this.userDataList = this.userHistory.result.data;
      this.dataSource = new MatTableDataSource(this.userDataList);
    });
  }

  docList() {
    this.docDetails = false;
  }

  traderData: any;
  traderDataList;
  selectedTrader;
  getTraderData() {
    this._userService.getTraderList().subscribe((data) => {
      this.traderData = data;
      this.traderDataList = this.traderData.result.data;
      this.selectedTrader = this.id.toLowerCase();
      // this.traderDataList.find(o => o.traderId.toLowerCase() === this.id.toLowerCase());
      this.selectName({ value: this.id });
    });
  }

  selectName(data) {
    var postdata = {
      userid: data.value,
    };
    this._userService.getUserVerificationHistory(postdata).subscribe((data) => {
      this.userHistory = data;
      this.userDataList = this.userHistory.result.data;
      this.dataSource = new MatTableDataSource(this.userDataList);
    });
  }

  getAlluser() {
    var postdata = {
      userId: this.selectedTrader,
      userRole: 'Trader',
      name: '',
      state: '',
      documentStatus: '',
      district: '',
      marketPlace: '',
      search: '',
      mobileNo: '',
      pageNumber: 0,
      adminRole: localStorage.getItem('UserRole'),
    };
    this._userService.getAllUser(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;
      //let selectedUser =  this.userlist.find(o => o.traderId.toLowerCase() === this.id.toLowerCase());

      this.companyname = this.userlist[0]['company'];
      //this.documentStatus = this.userlist[0]['adminStatus']
      // this.mandi = data.mandi
      this.personName = this.userlist[0]['personName'];
      this.phoneNo = this.userlist[0]['phoneNo'];
      //  this.role = data.role
      this.states = this.userlist[0]['states'];
      //  this.address = data.address
      this.emailId = this.userlist[0]['emailId'];
      this.TraderId = this.userlist[0]['personId'];
      this.district = this.userlist[0]['district'];
      //this.rejectedReason = this.userlist[0]['rejectedReason']
    });
  }

  filterDocuments;
  showurl;
  filterdocumentfrombase64;
  items: GalleryItem[];
  // imageData = data;

  documentlist = [];
  inprogress = false;
  rejected = false;
  listurl = [];
  base64;
  companyname;
  documentStatus;
  mandi;
  personName;
  phoneNo;
  role;
  states;
  imageSource;
  soure;
  items1;
  imgshow;
  TraderId;
  id_data;
  showurldata;
  showtext;
  items_url;
  items_find_url;
  iddocument;
  base123;
  test;
  pdfprint;
  pdfurl;
  pdfdata;
  filetype;
  filetypereal;
  address;
  emailId;
  rejectedReason;
  district;
  showDocument(data) {
    // this.userlist = [];
    this.getAlluser();
    this.docDetails = true;
    this.showinput = false;
    this.documentbutton = false;

    this.filterDocuments = data;
    this.id_data = data.personId;

    this.documentStatus = data['status'];
    this.rejectedReason = data['comment'];

    if (this.documentStatus == 'InProgress') {
      this.inprogress = true;
    } else if (this.documentStatus == 'InProgress') {
      this.rejected = true;
    }
    this.filterDocuments = data;
    this.documentlist = this.filterDocuments.docuements;

    var postdata = {
      userid: this.selectedTrader,
      latestVersion: data.latestVersion,
    };

    this._userService
      .getUserVerificationDocumentList(postdata)
      .subscribe((dcumentdata) => {
        // this.showDocument(data);
        setTimeout(() => {
          this.filtershow = false;
          // this.selectedIndex = 3;
          this.base64 = dcumentdata;
          this.listurl = this.base64.result.data;
          this.filetype = this.listurl.map(
            (item) => new ImageItem({ src: item.documentType })
          );
          this.filetype.forEach((element) => {
            this.filetypereal = element.data.src;
          });
          // this.base123 = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64,${this.listurl[0].documentUrl}`);
          // this.test =this.base123.changingThisBreaksApplicationSecurity;
          this.pdfdata = this.listurl.map(
            (item) =>
              new ImageItem(
                this.sanitizer.bypassSecurityTrustResourceUrl(
                  `data:application/pdf;base64,${item.documentUrl}`
                )
              )
          );
          this.pdfprint = this.pdfdata.map(
            (item) =>
              new ImageItem({
                src: item.data.changingThisBreaksApplicationSecurity,
              })
          );
          // this.pdfurl = this.pdfprint.map(item => new ImageItem({ src: item.data.src }));

          this.items_url = this.listurl.map(
            (item) =>
              new ImageItem(
                this.sanitizer.bypassSecurityTrustResourceUrl(
                  `data:image/png;base64,${item.documentUrl}`
                )
              )
          );
          this.items_find_url = this.items_url.map(
            (item) =>
              new ImageItem({
                src: item.data.changingThisBreaksApplicationSecurity,
              })
          );

          // // this.spinner.hide()
          // this.filtershow =false;
          //this.selectedIndex = 3;
          //this.ref.detectChanges();
        });
      });
  }
}
